module.exports = __webpack_public_path__ + "img/chatExample.6701f066.png";